import { AnimatePresence, motion } from "framer-motion";

export default function Card({ label, value, hint }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      whileHover={{ y: -2 }}
      className="rounded-3xl border border-slate-200/70 bg-white/70 backdrop-blur-xl shadow-[0_8px_30px_rgba(15,23,42,0.06)] p-4"
    >
      <div className="text-xs font-medium text-slate-500">{label}</div>
      <div className="text-2xl font-semibold tracking-tight text-slate-900 mt-1">{value}</div>
      {hint ? <div className="text-[11px] text-slate-500 mt-1">{hint}</div> : null}
    </motion.div>
  );
}
